/** The logging seam's payload — no identity, roles, or tenant values (VI.3). */
export interface NavigationLogEntry {
  /** Destination URL after navigation ends. */
  readonly url: string;
  /** null on the first navigation. */
  readonly previousUrl: string | null;
  /** ISO-8601 UTC instant. */
  readonly at: string;
  /** Navigation start → end. */
  readonly durationMs: number;
}

/**
 * Replaceable seam (FR-037): AITH-38 swaps the sink for Application Insights
 * by changing one provider; call sites never change.
 */
export abstract class NavigationLogger {
  abstract logNavigation(entry: NavigationLogEntry): void;
}
